import axios from "axios";
import store from "../store/index";
import { USER_TOKEN, CURRENT_PUBLISHER_SIMPLE } from "../store/mutation-types";
import { initServerError } from "./errors";

export const timeout = 25000;
export const baseURL = `${process.env.VUE_APP_API_URL}/api/v1/`;
export const service = axios.create({
  baseURL: baseURL,
  timeout, // 请求超时时间
});
service.interceptors.request.use(
  (config) => {
    config.headers["x-apphi-app-id"] = "com.apphi.web.post";
    config.headers["app-id"] = "com.apphi.web.post";
    // 如果是忽略token模式则不传authorization
    if (!config.ignoreToken) {
      config.headers.Authorization = store.getters[USER_TOKEN];
      // 如果设置了X-Apphi-Request-Publisher-Id头 则采用设置头
      if (!(config.headers && config.headers["X-Apphi-Request-Publisher-Id"])) {
        // 将当前选中publisher放入header中
        const publisher = store.getters[CURRENT_PUBLISHER_SIMPLE];
        if (publisher) {
          config.headers["X-Apphi-Request-Publisher-Id"] =
            publisher.publisherId;
        }
      }
    }
    // 每次请求统一显示Loading 但是某些接口忽略loading显示
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    // eslint-disable-next-line
    return Promise.reject(error);
  }
);
// 通用响应拦截器
service.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    return Promise.reject(initServerError(error));
  }
);
export default service;
